'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M24 22.017c0 .314-.015.785-.045 1.413H.022v-.695c0-.314-.007-.554-.022-.718 0-.449.007-.725.022-.83.18-.733.658-1.368 1.436-1.907a8.418 8.418 0 0 1 2.512-1.188 19.222 19.222 0 0 0 2.804-1.055c.972-.448 1.697-.934 2.176-1.458.254-.329.38-.613.38-.852 0-.329-.081-.875-.246-1.637a5.085 5.085 0 0 0-.224-.83c-.09-.24-.21-.486-.36-.74a6.245 6.245 0 0 1-.358-.696c-.224-.523-.471-1.51-.74-2.96a10.774 10.774 0 0 1-.135-1.683c0-1.57.404-2.826 1.212-3.768C9.286 1.471 10.459 1 12 1c1.54 0 2.721.471 3.544 1.413.822.942 1.219 2.198 1.189 3.768 0 .464-.053 1.025-.157 1.683-.21 1.33-.449 2.317-.718 2.96-.09.21-.202.441-.337.696-.134.254-.254.5-.358.74-.105.24-.187.516-.247.83-.165.762-.247 1.308-.247 1.637 0 .27.127.553.381.852.464.539 1.19 1.025 2.176 1.458.987.434 1.922.785 2.804 1.055.882.269 1.712.665 2.49 1.188.777.524 1.256 1.16 1.435 1.907.03.12.045.396.045.83Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
});
var User = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.User = User;